import { useTheme } from "@hooks/useTheme";

const UserAvatar = ({
  size = "md",
  className = "",
  fallbackText = "U",
  "data-testid": dataTestId = "user-avatar",
}) => {
  const { colors } = useTheme();
  const sizeClasses = {
    sm: "h-6 w-6 text-xs",
    md: "h-8 w-8 text-sm",
    lg: "h-10 w-10 text-base",
    xl: "h-12 w-12 text-lg"
  };
  // Fallback avatar with initials
  return (
    <div
      className={`flex items-center justify-center rounded-full ${colors.bgActivePrimary} ${colors.textNormal} font-medium ${sizeClasses[size]} ${className}`}
      data-testid={dataTestId}
    >
      {fallbackText.toString().charAt(0).toUpperCase()}
    </div>
  );
};

export default UserAvatar; 